import { render, staticRenderFns } from "./CustomerShow.vue?vue&type=template&id=100f94d1&scoped=true&"
import script from "./CustomerShow.vue?vue&type=script&lang=js&"
export * from "./CustomerShow.vue?vue&type=script&lang=js&"
import style0 from "./CustomerShow.vue?vue&type=style&index=0&id=100f94d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100f94d1",
  null
  
)

export default component.exports